import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import { useLocation } from 'react-router-dom';

interface LanguageContextType {
  language: 'en' | 'ar';
  setLanguage: (lang: 'en' | 'ar') => void;
}

const LanguageContext = createContext<LanguageContextType | undefined>(undefined);

export const LanguageProvider = ({ children }: { children: ReactNode }) => {
  const location = useLocation();
  
  // Detect language from URL path
  const path = location.pathname;
  let initialLang: 'en' | 'ar' = 'en'; // default to English
  
  if (path.startsWith('/ar-eg/')) {
    initialLang = 'ar';
  } else if (path.startsWith('/en-eg/')) {
    initialLang = 'en';
  }
  
  const [language, setLanguage] = useState<'en' | 'ar'>(initialLang);

  // Update language when URL changes
  useEffect(() => {
    const path = location.pathname;
    if (path.startsWith('/ar-eg/')) {
      setLanguage('ar');
    } else if (path.startsWith('/en-eg/')) {
      setLanguage('en');
    }
  }, [location.pathname]);

  return (
    <LanguageContext.Provider value={{ language, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) throw new Error('useLanguage must be used within a LanguageProvider');
  return context;
}; 